import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SnMedia } from '@lib/api/entities';

@Component({
  selector: 'sn-location-media-list',
  templateUrl: './location-media-list.component.html',
  styleUrls: ['./location-media-list.component.scss'],
})
export class LocationMediaListComponent {
  @Input()
  public media: any[];

  @Output()
  public readonly fileDeleted = new EventEmitter<SnMedia>();

  constructor() {}

  public emitItem(item: SnMedia): void {
    this.fileDeleted.emit(item);
  }
}
